/*
---------------------------------------------------------
Copyright © 2026 Daniel Woik (DW E-Commerce). All rights reserved.
Custom-coded by DW E-Commerce. This code is licensed for use on
this store only, as part of the DW E-Commerce optimization service.
Copying, reselling, redistributing or using it on any other store
is not permitted without written permission.
---------------------------------------------------------
DW Kit:   Search
Version:  1.0.0
Updated:  2026-10-14 — First version.
Source:   DW-Component-Library/Kits/Search

FUNCTION LOCKED. Theme-independent. Opens from [data-dw-search-open] and
from links to the search page; loads Shopify predictive search
(sections/dw-search-results.liquid) while typing, 250 ms after the last key.
Window API: window.DWSearch.open(), .close()
---------------------------------------------------------
*/
(function () {
  if (window.customElements.get('dw-search')) return;

  var DESKTOP = '(min-width: 990px)';

  class DWSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-dw-search-input]');
      this.start = this.querySelector('[data-dw-search-start]');
      this.results = this.querySelector('[data-dw-search-results]');
      this.grid = this.querySelector('[data-dw-search-grid]');
      this.suggest = this.querySelector('[data-dw-search-suggest]');
      this.empty = this.querySelector('[data-dw-search-empty]');
      this.all = this.querySelector('[data-dw-search-all]');
      this.titleEl = this.querySelector('[data-dw-search-products-title]');
      this.clearBtn = this.querySelector('[data-dw-search-clear]');
      this.timer = null;
      this.controller = null;
      this.lastFocus = null;
      this.cache = {};

      this.onDocClick = this.onDocClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onResize = this.onResize.bind(this);
      document.addEventListener('click', this.onDocClick, true);
      document.addEventListener('keydown', this.onKey);
      window.addEventListener('resize', this.onResize, { passive: true });

      var self = this;
      this.input.addEventListener('input', function () { self.queue(); });
      this.clearBtn.addEventListener('click', function () {
        self.input.value = '';
        self.input.focus();
        self.show('');
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick, true);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('resize', this.onResize);
    }

    headerBottom(trigger) {
      var header = trigger && trigger.closest('header, [id*="header"], .header, .shopify-section-group-header-group');
      if (!header) header = document.querySelector('header, .shopify-section-group-header-group');
      return header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    }

    onResize() {
      if (this.classList.contains('dw-is-open')) this.style.setProperty('--dw-search-top', this.headerBottom(this.trigger) + 'px');
    }

    open(trigger) {
      if (window.DWMenu) window.DWMenu.close();
      this.trigger = trigger || null;
      this.lastFocus = document.activeElement;
      this.style.setProperty('--dw-search-top', window.matchMedia(DESKTOP).matches ? this.headerBottom(trigger) + 'px' : '0px');
      this.classList.add('dw-is-open');
      document.documentElement.style.overflow = 'hidden';
      var input = this.input;
      window.setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
    }

    close() {
      if (!this.classList.contains('dw-is-open')) return;
      this.classList.remove('dw-is-open');
      document.documentElement.style.overflow = '';
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }

    queue() {
      var self = this;
      var q = this.input.value.trim();
      this.clearBtn.hidden = q.length === 0;
      window.clearTimeout(this.timer);
      if (!q) { this.show(''); return; }
      this.timer = window.setTimeout(function () { self.fetch(q); }, 250);
    }

    fetch(q) {
      var self = this;
      if (this.cache[q]) { this.render(q, this.cache[q]); return; }
      if (this.controller) this.controller.abort();
      this.controller = 'AbortController' in window ? new AbortController() : null;
      var url = this.dataset.url + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=12&resources[limit_scope]=each&resources[options][prefix]=last' +
        '&section_id=dw-search-results';
      fetch(url, { credentials: 'same-origin', signal: this.controller ? this.controller.signal : undefined })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          self.cache[q] = html;
          if (self.input.value.trim() === q) self.render(q, html);
        })
        .catch(function () {});
    }

    show(q) {
      this.start.hidden = !!q;
      this.results.hidden = !q;
    }

    render(q, html) {
      var doc = new DOMParser().parseFromString(html || '', 'text/html');
      var root = doc.querySelector('[data-dw-search-root]');
      var products = root ? root.querySelector('[data-dw-search-part="products"]') : null;
      var queries = root ? root.querySelector('[data-dw-search-part="queries"]') : null;
      var cols = root ? root.querySelector('[data-dw-search-part="collections"]') : null;

      this.grid.innerHTML = '';
      var count = 0;
      if (products) {
        var self = this;
        Array.prototype.forEach.call(products.children, function (item) {
          self.grid.appendChild(document.importNode(item, true));
          count++;
        });
      }

      this.suggest.innerHTML = '';
      [queries, cols].forEach(function (part) {
        if (!part) return;
        Array.prototype.forEach.call(part.children, function (chip) {
          this.suggest.appendChild(document.importNode(chip, true));
        }, this);
      }, this);
      this.suggest.hidden = this.suggest.children.length === 0;

      this.titleEl.hidden = count === 0;
      this.empty.hidden = count > 0;
      this.all.hidden = count === 0;
      this.all.href = this.dataset.searchUrl + '?q=' + encodeURIComponent(q) + '&options[prefix]=last';
      this.show(q);
    }

    onDocClick(event) {
      var t = event.target instanceof Element ? event.target : null;
      if (!t) return;
      if (this.contains(t)) {
        if (t.closest('[data-dw-search-close]')) { event.preventDefault(); this.close(); }
        return;
      }
      var opener = t.closest('[data-dw-search-open]');
      if (!opener) {
        var a = t.closest('a[href]');
        if (a) {
          try {
            var u = new URL(a.getAttribute('href'), window.location.origin);
            var path = new URL(this.dataset.searchUrl, window.location.origin).pathname.replace(/\/$/, '');
            if (u.origin === window.location.origin && u.pathname.replace(/\/$/, '') === path && !u.searchParams.get('q')) opener = a;
          } catch (e) {}
        }
      }
      if (opener) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.classList.contains('dw-is-open')) this.close(); else this.open(opener);
      }
    }

    onKey(event) {
      if (event.key === 'Escape' && this.classList.contains('dw-is-open')) this.close();
    }
  }

  customElements.define('dw-search', DWSearch);

  window.DWSearch = {
    open: function () { var s = document.querySelector('dw-search'); if (s) s.open(); },
    close: function () { var s = document.querySelector('dw-search'); if (s) s.close(); }
  };
})();
